<template>
  <div class="modal topup-modal">
    <div class="overlay" @click="$parent.closeTopUpModal"></div>
    <div class="wrapper">
      <div class="container">
        <div class="form">
          <div class="form-wrapper">
            <img
              class="close"
              @click="$parent.closeTopUpModal"
              src="./../img/close.svg"
            />
            <div class="form-fields">
              <div class="form-fields-wrapper">
                <div class="title">
                  <b>Top up</b>
                </div>
                <label>
                  <div class="title small cur">
                    {{ currency ? currency : currencyCode }}
                  </div>
                  <div class="desc"></div>
                  <input
                    type="text"
                    @input="allowOnlyNumbers"
                    placeholder="Enter amount"
                    v-model="amount"
                  />
                </label>
                <div class="packs" v-if="packs.length">
                  <slick
                    ref="slick"
                    :options="slickOptions"
                    class="packs-slider"
                  >
                    <div
                      :class="['item', { active: activePackId == pack.id }]"
                      v-for="(pack, index) in packs"
                      :key="index"
                      @click="setActivePack(pack)"
                    >
                      <div class="desc big">
                        <b>{{ pack.title }}</b>
                      </div>
                      <div class="desc small">
                        {{ pack.description }}
                      </div>
                      <div class="flex items-center justify-center">
                        <div class="left">
                          <div class="desc big">
                            <b
                              >{{ pack.price }}
                              {{ currency ? currency : currencyCode }}</b
                            >
                          </div>
                        </div>
                      </div>
                    </div>
                  </slick>
                </div>
                <button
                  :disabled="
                    $parent.minOrderAmount && $parent.minOrderAmount > amount
                  "
                  @click="toCheckout"
                  class="button"
                >
                  Next
                </button>
                <transition name="slide">
                  <div v-if="$parent.error" class="error-desc desc red">
                    {{ $parent.error }}
                  </div>
                </transition>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Slick from "vue-slick";
export default {
  name: "TopUpModal",
  props: ["currency", "currencyCode"],
  components: {
    Slick,
  },
  data: function () {
    return {
      amount: "",
      packs: [],
      activePackId: {},
      slickOptions: {
        slidesToShow: 2,
        slidesToScroll: 1,
        arrows: true,
        infinite: false,
        dots: false,
      },
    };
  },
  mounted() {
    if (!this.packs.length) {
      this.fetchPacks();
    }
  },
  methods: {
    setActivePack(pack) {
      this.amount = pack.price;
      this.activePackId = pack.id;
    },
    fetchPacks() {
      this.$http
        .get(process.env.VUE_APP_API + "packs")
        .then((res) => {
          this.packs = res.data.payload;
        })
        .catch((res) => {
          console.log(res);
        });
    },
    allowOnlyNumbers() {
      this.amount = this.amount.replace(/[^0-9.,]/g, "");
      const parts = this.amount.split(/[.,]/);
      const integerPart = parts[0];
      let decimalPart = parts[1];
      if (decimalPart !== undefined && decimalPart.length > 2) {
        decimalPart = decimalPart.slice(0, 2);
      }
      this.amount =
        decimalPart !== undefined
          ? `${integerPart}.${decimalPart}`
          : integerPart;
    },
    toCheckout() {
      this.$emit("setTopUpAmount", this.amount, this.activePackId);
    },
  },
};
</script>

<style lang="scss" scoped>
.packs {
  margin-top: 42px;
  .item {
    text-align: center;
    border: 2px solid #fff;
    border-radius: 8px;
    padding: 8px;
    cursor: pointer;
    cursor: pointer;

    .desc.small {
      margin-top: 8px;
      min-height: 105px;
    }
    .flex {
      margin-top: 8px;
    }
    &.active {
      background: #fff;
      .desc {
        color: #343a4a;
      }
    }
  }
}
</style>
